module.exports = __webpack_public_path__ + "static/media/shopper-groups-1.0d6cc32e.png";